/*
  NAVEE 定制：底部固定条上的加购按钮。

  按钮本身靠 HTML 的 form="product-form-xxx" 提交商品表单，加购和打开抽屉
  全由主题的 <product-form> 处理，这里不重复任何加购逻辑。这个脚本只负责
  把真正那颗加购按钮的状态同步过来：

  - 缺货 / 未选规格（disabled 或 aria-disabled）→ 不提交，滚回商品表单让用户处理
  - 提交中（is-loading）→ 固定条上的按钮也转圈，主题的 .btn.is-loading 样式现成的
*/
(function () {
  function init() {
    var proxy = document.querySelector('[data-sticky-atc-submit]');
    if (!proxy || proxy.dataset.stickyAtcInit === '1') return;

    var realBtn = proxy.form && proxy.form.querySelector('[name="add"]');
    if (!realBtn) return;

    proxy.dataset.stickyAtcInit = '1';

    function isBlocked() {
      return realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
    }

    function sync() {
      // 用 aria-disabled 而不是 disabled：disabled 的按钮收不到 click，
      // 就没法在未选规格时把用户带回选择器。
      proxy.setAttribute('aria-disabled', isBlocked() ? 'true' : 'false');
      proxy.classList.toggle('is-loading', realBtn.classList.contains('is-loading'));
    }

    new MutationObserver(sync).observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
    sync();

    proxy.addEventListener('click', function (event) {
      if (!isBlocked()) return;

      // 加不了购物车时别提交（提交也只会在页面上方那个看不见的
      // 错误提示里报错），滚回商品表单，让用户看到是缺货还是没选规格。
      event.preventDefault();
      var anchor = document.getElementById(proxy.dataset.stickyAtcAnchor);
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
